import { AppState } from 'pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { ComponentProps, ActionProps } from './props';
import { Scanner } from './component';
import { ScanAction } from './actions';
import { ScanAttemptAction } from 'components/main/actions';

const mapStateToProps = (state: AppState) => {
  return {};
};

function mapDispatchToProps(dispatch: Dispatch<ScanAction>, props: ComponentProps): ActionProps {
  return {
    onBarcodeScanned: (barcode: string, isCapsLockOn: boolean, isSeparatorMissing: boolean) =>
      dispatch(new ScanAction(props.scannerActionType, barcode, isCapsLockOn, isSeparatorMissing)),
    onScanAttempt: (output: string) => dispatch(new ScanAttemptAction(output))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Scanner);


// WEBPACK FOOTER //
// ./src/components/scanner/index.ts